import { render } from "./ServicePhasesCard.vue?vue&type=template&id=a9d2a182&ts=true"
import script from "./ServicePhasesCard.vue?vue&type=script&lang=ts"
export * from "./ServicePhasesCard.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/witteveenbos/witteveenbos-light-modules/corporate-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__